import { render, staticRenderFns } from "./MenuReportStaff.vue?vue&type=template&id=6ef9018e&scoped=true&"
import script from "./MenuReportStaff.vue?vue&type=script&lang=js&"
export * from "./MenuReportStaff.vue?vue&type=script&lang=js&"
import style0 from "./MenuReportStaff.vue?vue&type=style&index=0&id=6ef9018e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef9018e",
  null
  
)

export default component.exports